import { render, staticRenderFns } from "./A2PWizardBrandUseCase.vue?vue&type=template&id=3f636d17&scoped=true"
import script from "./A2PWizardBrandUseCase.vue?vue&type=script&lang=js"
export * from "./A2PWizardBrandUseCase.vue?vue&type=script&lang=js"
import style0 from "./a2p-wizard.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./A2PWizardBrandUseCase.vue?vue&type=style&index=1&id=3f636d17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f636d17",
  null
  
)

export default component.exports